var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path8, _path9, _path10, _path11, _path12, _ellipse5, _ellipse6, _path13, _path14, _g2, _path15, _rect2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _rect4, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _rect5, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSphereInfoFooterV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 256,
    viewBox: "0 0 213 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4798_72393)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.373,
    cy: 127.382,
    rx: 91.732,
    ry: 91.6202,
    fill: "url(#paint0_radial_4798_72393)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.254 27.9105L119.667 28.9485L118.435 28.0432L118.151 28.3342L117.617 28.2916L118.091 28.4836L118.172 28.6906L118.695 30.5265L119.812 31.8493L119.59 32.3971L120.572 33.375L120.951 33.5286L120.895 32.5782L121.464 32.8086L121.666 32.3106L121.225 31.0879L120.704 30.8767L120.521 30.1064L121.042 30.7237L121.548 29.4788L122.338 28.349L122.276 27.686L123.026 26.6559L122.477 25.9695L122.659 25.5213L122.124 24.2602L120.713 27.0526L120.375 27.2056L120.254 27.9105Z",
    fill: "#F7F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.597 28.6899L120.01 29.7279L119.968 31.5088L120.575 33.379L120.954 33.5326L120.899 32.5822L121.468 32.8126L121.67 32.3146L120.708 30.8807L120.524 30.1104L121.046 30.7277L121.552 29.4828L122.342 28.353L122.28 27.69L123.03 26.6598L122.481 25.9735L122.663 25.5253L122.466 25.0396L121.056 27.8319L120.718 27.9849L120.597 28.6899Z",
    fill: "#9AB7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.715 30.3431L111.288 31.8627L110.9 32.1511L110.291 32.0527L109.969 30.9814L109.644 30.8495L108.405 31.6347L104.937 31.9126L104.901 31.601L108.34 31.2618L109.265 30.4487L109.078 29.9768L109.698 29.7825L110.715 30.3431Z",
    fill: "#9AB7BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.253 28.7912L109.68 29.8601L109.366 30.3491L108.179 31.4357L104.498 31.736L104.252 31.6362L104.713 31.2071L103.629 30.7678L104.623 30.7226L106.55 29.9356L107.415 29.5021L108.105 29.7817L107.798 29.2654L106.122 28.5863L105.114 27.1136L106.081 27.8415L107.331 28.0123L109.253 28.7912Z",
    fill: "#F7F9FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.859 128.807C212.399 125.835 210.422 123.017 207.443 122.514C202.678 121.708 198.116 124.909 197.253 129.664L194.879 142.745L208.899 145.117L211.859 128.807Z",
    fill: "#BCD6DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.384 128.081C208.91 125.183 206.982 122.436 204.078 121.945C201.175 121.454 198.394 123.404 197.868 126.302L194.884 142.746L205.399 144.525L208.384 128.081Z",
    fill: "#F6F8F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.26587,
    height: 1.37783,
    transform: "matrix(-0.985997 -0.166775 -0.178563 0.983931 203.371 135.799)",
    fill: "#BCD6DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.168 131.392L202.102 126.851L202.25 130.02L200.147 129.664L202.151 134.544L202.065 131.037L204.168 131.392Z",
    fill: "#9AB7BD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 169.238 128.699)",
    fill: "#BCD6DC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 146.801 124.902)",
    fill: "#BCD6DC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 159.348 127.026)",
    fill: "#BCD6DC"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 183.133 131.05)",
    fill: "#BCD6DC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.387 130.163L158.378 132.868L191.196 138.419L194.011 137.644L194.816 135.11L194.48 133.634L194.482 130.297L192.107 128.644C192.107 128.644 190.6 126.186 188.745 124.821C186.89 123.456 184.623 122.372 182.601 122.03L164.356 118.944L154.266 122.243L147.515 122.353L144.168 123.205L142.49 124.841L141.697 129.212L142.387 130.163Z",
    fill: "#9AB7BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.197 130.241L141.891 128.16L142.493 124.841L144.156 123.286L147.518 122.353L154.254 122.324L164.359 118.944C164.359 118.944 181.393 121.807 182.606 122.012C183.82 122.218 185.367 122.882 185.367 122.882L174.598 121.009L170.215 125.191L160.904 125.618L159.159 128.577L153.633 127.643L151.875 127.345L150.429 128.185L155.284 129.007L154.197 130.241Z",
    fill: "#F7F9FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.987 124.649L155.345 122.511L164.54 119.394L173.079 120.838L167.987 124.649Z",
    fill: "#BCD6DC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.313 125.969L189.526 128.542C189.526 128.542 189.259 126.767 186.917 124.847C184.576 122.928 181.914 122.249 181.914 122.249L174.609 121.013L170.595 124.589L172.101 124.844L171.618 124.179L173.021 123.581L175.218 124.787L174.313 125.969Z",
    fill: "#BCD6DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.384 125.616L144.808 123.482L144.054 123.354L142.49 124.842L142.919 125.332L143.23 126.469L149.928 127.602L151.458 126.776L158.909 128.036L160.384 125.616Z",
    fill: "#F9F9F9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 160.359 127.197)",
    fill: "#BCD6DC"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.24544,
    cy: 4.77188,
    rx: 4.24544,
    ry: 4.77188,
    transform: "matrix(0.985997 0.166775 -0.178563 0.983931 184.133 131.219)",
    fill: "#BCD6DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.691 124.725L170.553 124.532L170.173 124.468L169.281 125.074L172.316 125.587L174.793 124.871L172.649 123.753L171.378 124.294L171.691 124.725Z",
    fill: "#F7F9FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4798_72393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 127,
    width: 35,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.476 129.738C170.7 128.507 169.881 127.34 168.648 127.132L168.413 127.092C168.049 127.031 167.701 127.275 167.635 127.638C167.569 128.001 167.811 128.345 168.174 128.407L168.213 128.413C168.791 128.511 169.174 129.057 169.07 129.634L168.244 134.185C167.849 136.359 169.295 138.42 171.473 138.788L195.426 142.839C197.059 143.116 198.623 142.018 198.919 140.388L199.435 137.545C199.534 137.002 200.055 136.636 200.6 136.728L201.016 136.799L201.262 135.443C199.713 135.181 198.23 136.221 197.95 137.767L197.399 140.804C197.3 141.348 196.779 141.713 196.234 141.621L171.123 137.374C170.034 137.19 169.311 136.159 169.508 135.073L170.476 129.738Z",
    fill: "#323548"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4798_72393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.481 129.739C170.704 128.508 169.885 127.341 168.652 127.133L168.417 127.093C168.053 127.032 167.705 127.276 167.639 127.639C167.573 128.002 167.815 128.346 168.179 128.408L168.217 128.414C168.795 128.512 169.178 129.059 169.074 129.635L168.248 134.186C167.853 136.36 169.299 138.421 171.477 138.789L195.43 142.841C197.063 143.117 198.628 142.019 198.924 140.389L199.516 137.122C199.573 136.813 199.869 136.605 200.179 136.657L201.743 136.922C202.118 136.985 202.477 136.733 202.545 136.359C202.613 135.985 202.364 135.63 201.989 135.566L200.265 135.275C199.269 135.106 198.316 135.775 198.136 136.769L197.403 140.805C197.304 141.349 196.783 141.715 196.238 141.622L171.127 137.375C170.038 137.191 169.315 136.16 169.513 135.074L170.481 129.739Z",
    fill: "#9AB7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.83 139.161L195.837 142.206C196.926 142.391 197.969 141.659 198.167 140.572L198.682 137.729C198.88 136.643 199.922 135.911 201.012 136.095L201.143 136.117L201.266 135.439L200.719 135.347C199.085 135.071 197.521 136.168 197.225 137.798L196.701 140.682C196.603 141.226 196.081 141.591 195.537 141.499L179.329 138.758L177.83 139.161Z",
    fill: "#F7F9FB"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.984 127.719C168.12 126.97 167.917 126.31 167.529 126.245C167.142 126.179 166.718 126.733 166.582 127.482C166.447 128.231 166.65 128.891 167.037 128.956C167.425 129.022 167.849 128.468 167.984 127.719Z",
    fill: "#BCD6DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.84543,
    height: 19.7582,
    transform: "matrix(0.808117 -0.589055 0.616065 0.78772 34.4961 134.525)",
    fill: "#9AB7BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.514 142.679L49.3409 148.851L47.0145 150.547L45.4421 148.536L44.514 142.679Z",
    fill: "#9AB7BD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.801 146.226L14.6467 142.203L13.9258 141.281L57.0146 128.962L57.5487 129.645L34.801 146.226Z",
    fill: "#9AB7BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9258 141.281L36.4569 124.858L57.0082 128.954L34.4771 145.377L13.9258 141.281Z",
    fill: "#9AB7BD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5586 140.75L22.0775 135.998L27.7124 137.153L21.1934 141.905L15.5586 140.75Z",
    fill: "#BCD6DC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9805 141.995L28.4994 137.243L34.1342 138.398L27.6153 143.15L21.9805 141.995Z",
    fill: "#BCD6DC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3867 143.245L34.9057 138.493L40.5405 139.648L34.0215 144.4L28.3867 143.245Z",
    fill: "#BCD6DC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4883 135.703L29.3036 130.735L35.0753 131.791L28.2601 136.758L22.4883 135.703Z",
    fill: "#BCD6DC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9023 136.943L35.7176 131.976L41.4894 133.031L34.6741 137.999L28.9023 136.943Z",
    fill: "#BCD6DC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3164 138.188L42.1317 133.221L47.9035 134.276L41.0882 139.244L35.3164 138.188Z",
    fill: "#BCD6DC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8594 130.325L36.3783 125.573L42.0132 126.729L35.4942 131.48L29.8594 130.325Z",
    fill: "#BCD6DC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2617 131.577L42.7807 126.825L48.4155 127.98L41.8965 132.732L36.2617 131.577Z",
    fill: "#BCD6DC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 132.824L49.1947 128.072L54.8296 129.228L48.3106 133.979L42.6758 132.824Z",
    fill: "#BCD6DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.11763,
    height: 28.6518,
    transform: "matrix(0.983064 -0.238537 0.248955 0.956254 41.0117 92.4912)",
    fill: "#9AB7BD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6189 108.829L52.4475 119.693L48.3521 120.687L47.4306 117.148L49.6189 108.829Z",
    fill: "#F7F9FB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5792 108.267L10.0475 91.9118L9.625 90.2891L74.3111 97.3484L74.6241 98.5506L34.5792 108.267Z",
    fill: "#9AB7BD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 90.2891L49.2886 80.6648L74.3074 97.334L34.6438 106.958L9.625 90.2891Z",
    fill: "#F7F9FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1016 90.4707L23.5774 87.6861L30.4184 92.2992L18.9426 95.0838L12.1016 90.4707Z",
    fill: "#BCD6DC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9336 95.627L31.4095 92.8424L38.2504 97.4555L26.7746 100.24L19.9336 95.627Z",
    fill: "#BCD6DC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7617 100.786L39.2376 98.0016L46.0786 102.615L34.6027 105.399L27.7617 100.786Z",
    fill: "#BCD6DC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3086 87.5059L36.3061 84.5947L43.3882 89.1493L31.3907 92.0605L24.3086 87.5059Z",
    fill: "#BCD6DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 92.6631L44.1459 89.7519L51.228 94.3065L39.2306 97.2177L32.1484 92.6631Z",
    fill: "#BCD6DC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.957 97.8262L51.9545 94.915L59.0366 99.4696L47.0392 102.381L39.957 97.8262Z",
    fill: "#BCD6DC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2734 84.3613L48.7493 81.5767L55.5903 86.1899L44.1144 88.9744L37.2734 84.3613Z",
    fill: "#BCD6DC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1016 89.5205L56.5774 86.7359L63.4184 91.349L51.9426 94.1336L45.1016 89.5205Z",
    fill: "#BCD6DC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9336 94.6797L64.4095 91.8951L71.2504 96.5082L59.7746 99.2928L52.9336 94.6797Z",
    fill: "#BCD6DC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1916 30.5456C60.247 29.4765 60.9486 28.5398 61.9819 28.1556L66.6742 26.4105L68.6918 31.4671L63.9995 33.2121C62.9662 33.5964 61.795 33.3562 61.0111 32.5992C60.4497 32.0573 60.152 31.311 60.1916 30.5456Z",
    fill: "#F7F9FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1959 30.5456C60.2512 29.4765 60.4335 30.4573 61.4669 30.073L66.6963 28.1282L68.6961 31.4671L64.0038 33.2121C62.9704 33.5964 61.7993 33.3562 61.0153 32.5993C60.454 32.0573 60.1562 31.3111 60.1959 30.5456Z",
    fill: "#9AB7BD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2678 31.4013L69.0325 30.3732L98.2699 97.9647L91.5555 100.462L66.2678 31.4013Z",
    fill: "#F7F9FB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1067 30.8205L68.6076 29.5679L70.1312 32.5499L68.9942 35.5536L92.4314 100.14L91.5598 100.465L66.1067 30.8205Z",
    fill: "#9AB7BD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0983 6.69686C58.009 6.63815 58.3584 5.48911 58.5443 4.92193C59.7951 7.02365 62.688 12.2079 64.2535 16.1312C65.8189 20.0544 67.4624 26.2397 68.0885 28.8419C67.067 28.0724 64.7206 25.7729 63.5066 22.7303C61.9891 18.9272 58.2101 6.77024 58.0983 6.69686Z",
    fill: "#F7F9FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3502 7.39994C58.2042 6.96338 58.115 6.71094 58.0991 6.70056C58.0811 6.68872 58.1769 6.95125 58.3502 7.39994C59.2353 10.0478 62.2046 19.4691 63.5074 22.734C64.7214 25.7766 67.0678 28.0761 68.0893 28.8456C67.4632 26.2434 63.8134 21.0212 62.248 17.0979C62.248 17.0979 59.2511 9.73279 58.3502 7.39994Z",
    fill: "#9AB7BD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1342 33.1442C85.1959 33.0901 85.858 34.2188 86.1813 34.7899C84.4796 34.6952 80.3319 34.2612 77.355 33.2825C74.3782 32.3038 69.8991 29.9015 68.0317 28.8227C68.801 28.27 70.9169 27.3542 73.2255 28.1132C76.1112 29.062 85.0571 33.2118 85.1342 33.1442Z",
    fill: "#F7F9FB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0317 28.8227C68.801 28.27 71.2495 29.5563 73.8894 31.1555C77.2224 32.8194 82.5008 34.4051 86.1813 34.7899C84.4796 34.6952 80.3319 34.2612 77.355 33.2825C74.3782 32.3038 69.8991 29.9015 68.0317 28.8227Z",
    fill: "#9AB7BD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4813 46.3381C59.5042 46.4564 58.4305 46.3852 57.8908 46.3348C58.4845 44.3153 60.0883 39.5526 61.7543 36.658C63.4203 33.7635 66.6446 30.1377 68.0485 28.6867C68.2397 30.0671 68.2992 33.3892 67.0072 35.634C65.3922 38.4399 59.4527 46.1902 59.4813 46.3381Z",
    fill: "#F7F9FB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0393 29.0206C67.5746 30.3623 68.7873 31.1604 69.7478 30.8032C70.7084 30.446 72.8172 28.4127 72.2818 27.071C71.7465 25.7293 68.7697 25.5872 67.8091 25.9444C66.8486 26.3017 66.5039 27.6789 67.0393 29.0206Z",
    fill: "#F7F9FB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0373 29.0201C67.5727 30.3618 68.7854 31.1599 69.7459 30.8027C70.2105 30.6299 70.9438 30.0649 71.5166 29.3757C73.1957 27.3553 71.4322 29.1652 69.2864 29.6405C67.4475 30.0479 66.502 27.6784 67.0373 29.0201Z",
    fill: "#9AB7BD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.59 58.7473C152.553 58.037 152.086 57.4154 151.399 57.1611L148.28 56.006L146.944 59.3672L150.063 60.5223C150.75 60.7766 151.528 60.616 152.048 60.1124C152.42 59.7518 152.617 59.2558 152.59 58.7473Z",
    fill: "#F7F9FB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M152.591 58.7494C152.553 58.0392 152.433 58.691 151.746 58.4366L148.27 57.1493L146.944 59.3694L150.063 60.5244C150.75 60.7788 151.528 60.6182 152.048 60.1145C152.421 59.754 152.618 59.2579 152.591 58.7494Z",
    fill: "#9AB7BD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M148.562 59.3235L146.724 58.6429L127.366 103.575L131.829 105.228L148.562 59.3235Z",
    fill: "#F7F9FB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.668 58.9371L147.005 58.1072L145.996 60.0897L146.754 62.0842L131.246 105.015L131.826 105.229L148.668 58.9371Z",
    fill: "#9AB7BD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M153.955 42.898C154.015 42.8589 153.781 42.0958 153.657 41.7192C152.828 43.1166 150.911 46.5635 149.875 49.1714C148.839 51.7793 147.753 55.89 147.34 57.6194C148.018 57.1073 149.574 55.5774 150.378 53.5549C151.382 51.0269 153.881 42.9468 153.955 42.898Z",
    fill: "#F7F9FB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M153.792 43.3662C153.888 43.0761 153.947 42.9083 153.958 42.9014C153.97 42.8935 153.906 43.068 153.792 43.3662C153.206 45.1262 151.243 51.3881 150.38 53.5583C149.577 55.5808 148.02 57.1107 147.342 57.6228C147.756 55.8934 150.175 52.4207 151.212 49.8128C151.212 49.8128 153.196 44.9169 153.792 43.3662Z",
    fill: "#9AB7BD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M136.025 60.4938C135.984 60.4579 135.545 61.2084 135.331 61.5881C136.461 61.5236 139.217 61.2315 141.193 60.5786C143.17 59.9257 146.143 58.3256 147.383 57.6072C146.871 57.2407 145.465 56.6342 143.932 57.1406C142.016 57.7735 136.076 60.5386 136.025 60.4938Z",
    fill: "#F7F9FB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M147.383 57.6072C146.871 57.2407 145.246 58.0975 143.494 59.1623C141.281 60.2708 137.776 61.3291 135.331 61.5881C136.461 61.5236 139.217 61.2315 141.193 60.5786C143.17 59.9257 146.143 58.3256 147.383 57.6072Z",
    fill: "#9AB7BD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M153.08 69.236C153.064 69.3146 153.778 69.2663 154.136 69.2324C153.74 67.8912 152.67 64.7285 151.56 62.807C150.45 60.8854 148.305 58.4796 147.371 57.5168C147.245 58.4341 147.209 60.6412 148.069 62.1314C149.145 63.9941 153.098 69.1377 153.08 69.236Z",
    fill: "#F7F9FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M148.039 57.7374C147.684 58.6293 146.879 59.1606 146.241 58.9241C145.602 58.6877 144.199 57.3388 144.554 56.4469C144.908 55.555 146.886 55.458 147.524 55.6944C148.163 55.9309 148.393 56.8455 148.039 57.7374Z",
    fill: "#F7F9FB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M148.036 57.7364C147.681 58.6283 146.877 59.1596 146.238 58.9232C145.929 58.8088 145.442 58.4341 145.06 57.9768C143.943 56.636 145.116 57.8368 146.542 58.1507C147.764 58.4196 148.39 56.8446 148.036 57.7364Z",
    fill: "#9AB7BD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.57413,
    height: 17.4233,
    transform: "matrix(-0.999929 -0.0119098 -0.0127783 0.999918 176.117 85.7402)",
    fill: "#BCD6DC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.396 94.6702L173.287 103.157L175.892 103.188L175.94 99.3594L173.396 94.6702Z",
    fill: "#F7F9FB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M183.354 70.0335L179.118 69.1703L176.376 68.3374L172.55 64.2887L165.761 68.211L163.273 78.1083L164.379 84.8095L166.502 86.7586L171.392 89.0431L182.189 90.5027L189.587 80.8936L187.328 73.0709L183.354 70.0335Z",
    fill: "#9AB7BD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M182.967 75.3007L183.04 69.5973L179.389 62.8989L173.78 71.0081L172.486 64.5279L165.756 68.2101L163.064 78.6328L164.374 84.8086L170.804 88.4657L169.746 83.8815L172.874 86.3479L175.299 75.2093L182.967 75.3007Z",
    fill: "#F7F9FB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M164.412 85.2632L169.6 89.1533L174.817 86.728L180.129 80.8643L168.025 78.5437L164.412 85.2632Z",
    fill: "#9AB7BD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M164.423 85.2629L166.654 86.9606L171.337 83.9266L166.685 84.5319L168.036 78.5433L164.423 85.2629Z",
    fill: "#F7F9FB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.571 82.9168L183.039 80.849L178.195 79.6172L177.534 87.6904L185.571 82.9168Z",
    fill: "#F7F9FB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M201.371 174.938L199.807 173.413L199.015 171.971L199.143 168.75L193.118 171.12L189.348 170.842L186.945 174.09L187.001 175.752L188.073 178.658L192.122 182.607L195.888 183.691L196.123 178.393L201.371 174.938Z",
    fill: "#9AB7BD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M197.035 174.796L201.271 175.162L202.607 170.901L197.773 171.75L199.018 168.832L192.993 170.855L189.04 170.985L186.948 174.094L188.077 178.189L189.594 175.847L192.586 178.108L194.924 175.253L197.035 174.796Z",
    fill: "#F7F9FB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M199.093 181.214L198.916 179.339L197.414 176.893L193.685 180.011L199.093 181.214Z",
    fill: "#F7F9FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.26697,
    height: 22.334,
    transform: "matrix(-0.931109 -0.364767 -0.387493 0.921884 165.289 203.183)",
    fill: "#9AB7BD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.528 213.137L153.312 223.167L156.39 224.373L158.292 219.848L157.528 213.137Z",
    fill: "#BCD6DC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M181.466 187.773L179.655 179.335L176.805 174.795L171.402 176.102L161.451 177.712L149.073 187.839L151.816 196.803L153.398 200.071L155.824 204.818L168.65 216.262L183.313 206.816L185.515 195.403L181.466 187.773Z",
    fill: "#9AB7BD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M173.821 189.802L179.663 179.334L176.814 174.794L167.98 184.09L169.15 176.392L161.459 177.711L149.081 187.838L151.825 196.803L155.832 204.818L158.651 198.113L161.178 202.446L167.171 201.451L162.394 192.465L173.821 189.802Z",
    fill: "#F7F9FB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M146.376 199.862L150.664 206.81L158.027 206.271L167.16 201.693L153.903 193.504L146.376 199.862Z",
    fill: "#9AB7BD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 199.857L148.19 202.874L155.213 201.373L149.397 200.004L153.885 193.499L146.359 199.857Z",
    fill: "#F7F9FB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M169.557 203.117L171.388 206.135L172.594 203.265L177.083 196.759L169.557 203.117Z",
    fill: "#F7F9FB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 170.939L144.53 171.354L145.526 171.538L147.416 170.898L148.12 172.359L146.935 178.863L146.401 178.594L145.404 178.857L143.488 178.777L141.151 177.598L139.917 173.863L140.942 172.688L143.064 170.939Z",
    fill: "#9AB7BD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.203 173.133L143.237 170.853L145.532 169.361L145.87 172.786L147.395 170.981L148.464 170.839L147.503 176.559L146.918 178.897L143.771 178.691L144.894 177.438L143.023 176.181L145.287 174.878L144.203 173.133Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M140.148 174.583L141.293 174.349L143.012 174.748L141.819 177.363L140.148 174.583Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6066 196.931L83.269 195.96L84.3033 195.216L85.3039 192.954L87.3284 193.572L92.6294 200.23L91.9094 200.482L91.3087 201.611L89.5867 203.277L86.4349 204.381L81.7462 202.291L81.4842 200.354L81.6066 196.931Z",
    fill: "#9AB7BD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7254 197.782L81.6803 196.699L82.2009 193.339L85.8198 195.974L85.3752 193.044L86.1554 191.954L90.8878 197.736L92.6566 200.272L89.7549 202.946L89.5009 200.853L86.6732 201.468L87.3507 198.299L84.7254 197.782Z",
    fill: "#F7F9FB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6385 202.706L83.3943 201.468L85.2578 200.255L86.7745 203.581L82.6385 202.706Z",
    fill: "#F7F9FB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5742 203.727L23.7956 210.657L29.0383 224.602L48.8169 217.672L43.5742 203.727Z",
    fill: "#BCD6DC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4782 203.756L48.0938 192.219L28.397 199.12L23.7815 210.658L43.4782 203.756Z",
    fill: "#9AB7BD"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6762 182.647L59.0183 173.511L51.5408 191.454L59.9318 213.774L85.0671 204.966L76.6762 182.647Z",
    fill: "#F7F9FB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M51.543 191.464L28.4679 199.549L36.8562 221.861L59.9313 213.776L51.543 191.464Z",
    fill: "#BCD6DC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8164 191.367L59.2305 173.438L35.8886 181.616L28.4746 199.545L51.8164 191.367Z",
    fill: "#9AB7BD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0964 217.747L22.6909 217.189L23.7252 216.444L24.7258 214.183L28.0797 217.716L30.7735 218.713L31.3313 221.71L30.7306 222.839L29.0086 224.505L24.8804 225.952L21.917 225.512L23.5469 221.785L21.0964 217.747Z",
    fill: "#9AB7BD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1395 219.011L21.0944 217.927L21.615 214.568L24.6612 216.677L24.7893 214.273L28.26 217.567L30.942 218.903L31.3329 221.707L29.1689 224.174L28.9149 222.081L26.0872 222.697L25.4407 219.991L24.1395 219.011Z",
    fill: "#F7F9FB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5565 222.788L21.3123 221.55L23.1758 220.337L24.6925 223.663L20.5565 222.788Z",
    fill: "#F7F9FB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1025 217.768L22.697 217.21L23.7302 216.463L24.7258 214.188L28.0922 217.754L30.7912 218.765L31.3574 221.785L30.7591 222.92L29.0399 224.594L24.9117 226.04L21.9445 225.59L23.5659 221.84L21.1025 217.768Z",
    fill: "#9AB7BD"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1614 219.049L21.1106 217.951L21.6228 214.569L24.6774 216.701L24.7993 214.279L28.282 217.606L30.97 218.958L31.3687 221.782L29.2093 224.262L28.9495 222.153L26.1208 222.766L25.4665 220.04L24.1614 219.049Z",
    fill: "#F7F9FB"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5723 222.846L21.3255 221.601L23.1875 220.384L24.7144 223.737L20.5723 222.846Z",
    fill: "#F7F9FB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4798_72393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.676 194.522H98.2026C96.4319 194.522 94.7928 193.3 93.8683 191.294L91.5742 186.31H127.302L125.007 191.294C124.086 193.3 122.444 194.522 120.673 194.522H120.676Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.302 186.31L125.008 191.294C124.086 193.3 122.444 194.522 120.674 194.522H98.2051C96.6821 194.522 95.25 193.615 94.2974 192.082C102.041 192.124 117.653 192.106 118.54 191.35C118.552 191.34 118.562 191.329 118.574 191.319C119.624 190.384 118.991 188.483 117.647 188.483H92.5739L91.5742 186.31H127.298H127.302Z",
    fill: "#BCD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.108 166.601H91.7645C90.7188 166.601 89.8711 167.396 89.8711 168.378V171.393C89.8711 172.375 90.7188 173.17 91.7645 173.17H127.108C128.153 173.17 129.001 172.375 129.001 171.393V168.378C129.001 167.396 128.153 166.601 127.108 166.601Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.108 173.168H91.7645C90.7188 173.168 89.8711 173.964 89.8711 174.945V177.961C89.8711 178.942 90.7188 179.738 91.7645 179.738H127.108C128.153 179.738 129.001 178.942 129.001 177.961V174.945C129.001 173.964 128.153 173.168 127.108 173.168Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.108 179.737H91.7645C90.7188 179.737 89.8711 180.533 89.8711 181.515V184.53C89.8711 185.511 90.7188 186.307 91.7645 186.307H127.108C128.153 186.307 129.001 185.511 129.001 184.53V181.515C129.001 180.533 128.153 179.737 127.108 179.737Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.002 168.378V171.393C129.002 172.377 128.162 173.17 127.127 173.17H98.3789C109.866 173.17 123.862 173.049 120.878 166.601H127.127C128.162 166.601 129.002 167.397 129.002 168.378Z",
    fill: "#BCD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.002 174.945V177.961C129.002 178.944 128.162 179.738 127.127 179.738H98.3789C109.866 179.738 123.862 179.616 120.878 173.168H127.127C128.162 173.168 129.002 173.965 129.002 174.945Z",
    fill: "#BCD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.002 181.515V184.53C129.002 185.513 128.162 186.307 127.127 186.307H98.3789C109.866 186.307 123.862 186.186 120.878 179.737H127.127C128.162 179.737 129.002 180.534 129.002 181.515Z",
    fill: "#BCD6DC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_4798_72393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.12 104.161C151.188 113.186 148.092 121.517 142.824 128.213C136.376 136.412 132.732 146.304 132.732 156.546V157.844C132.732 162.679 128.616 166.598 123.537 166.598H95.341C90.2627 166.598 86.1466 162.679 86.1466 157.844V156.981C86.1466 146.543 82.475 136.453 75.9439 128.07C70.8012 121.473 67.7578 113.3 67.7578 104.45C67.7578 82.4374 86.5849 64.6091 109.743 64.7667C132.431 64.9213 150.958 82.5599 151.117 104.161H151.12Z",
    fill: "url(#paint1_radial_4798_72393)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.431 127.904L142.431 127.904C135.919 136.185 132.232 146.184 132.232 156.546V157.844C132.232 162.38 128.363 166.098 123.537 166.098H95.341C90.5154 166.098 86.6466 162.38 86.6466 157.844V156.981C86.6466 146.425 82.9331 136.228 76.3383 127.763L76.3382 127.763C71.2603 121.249 68.2578 113.183 68.2578 104.45C68.2578 82.7377 86.8355 65.1108 109.739 65.2666C132.177 65.4196 150.46 82.8594 150.617 104.165L150.621 104.652C150.575 113.37 147.538 121.413 142.431 127.904Z",
    stroke: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bf_4798_72393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.119 104.158C151.187 113.183 148.085 121.517 142.808 128.213C136.343 136.412 132.695 146.301 132.695 156.546V157.844C132.695 162.679 128.57 166.598 123.481 166.598H95.2249C90.1357 166.598 86.011 162.679 86.011 157.844V156.981C86.011 150.039 84.3832 143.252 81.3672 137.019C81.3672 137.019 87.7186 141.641 91.6898 147.859C95.1358 153.252 101.3 156.54 107.94 156.54C112.249 156.54 116.294 155.166 119.534 152.802C122.774 150.439 125.216 147.083 126.319 143.127C128.272 136.115 131.334 127.519 135.892 120.344C145.416 105.349 134.258 57.0809 84.3218 72.68C91.3735 67.6554 100.151 64.7025 109.657 64.7667C132.394 64.9213 150.96 82.5599 151.119 104.158Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.48 201.09H105.395C103.392 201.09 101.524 199.955 100.434 198.073L98.3789 194.521H120.496L118.441 198.073C117.353 199.955 115.486 201.09 113.48 201.09Z",
    fill: "#BCD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2607 94.4264C86.4702 104.287 85.3262 114.287 78.6776 110.536C72.0261 106.785 71.3303 95.7472 77.1209 85.8832C82.9115 76.0221 92.9949 71.0685 99.6464 74.8198C106.295 78.5712 98.0513 84.5624 92.2607 94.4264Z",
    fill: "url(#paint2_linear_4798_72393)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9747 170.447C94.9747 170.136 94.5939 169.884 94.1241 169.884C93.6543 169.884 93.2734 170.136 93.2734 170.447V170.963C93.2734 171.274 93.6543 171.526 94.1241 171.526C94.5939 171.526 94.9747 171.274 94.9747 170.963V170.447Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9747 175.939C94.9747 175.317 94.5939 174.812 94.1241 174.812C93.6543 174.812 93.2734 175.317 93.2734 175.939V176.971C93.2734 177.593 93.6543 178.097 94.1241 178.097C94.5939 178.097 94.9747 177.593 94.9747 176.971V175.939Z",
    fill: "#F7F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9747 182.508C94.9747 181.885 94.5939 181.381 94.1241 181.381C93.6543 181.381 93.2734 181.885 93.2734 182.508V183.539C93.2734 184.161 93.6543 184.666 94.1241 184.666C94.5939 184.666 94.9747 184.161 94.9747 183.539V182.508Z",
    fill: "#F7F9FB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4798_72393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.773 97.8074C108.224 103.81 102.445 114.224 102.445 125.418V146.618L106.19 144.031C113.375 139.07 117.485 130.361 117.485 125.128L116.959 124.684C114.105 122.281 114.44 117.829 117.623 115.869C125.622 110.837 130.468 102.111 130.468 92.7339V89.8213L117.773 97.8074Z",
    fill: "url(#paint3_linear_4798_72393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.202 127.845C117.382 127.094 117.484 125.128 117.484 125.128C117.484 113.933 111.872 103.81 102.324 97.8015L89.6289 89.8213V92.7576C89.6289 102.123 94.4688 110.837 102.455 115.857L114.642 123.21C114.642 123.21 117.579 124.933 117.202 127.84V127.845Z",
    fill: "url(#paint4_linear_4798_72393)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4798_72393)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5962,
    cy: 10.5026,
    rx: 91.5962,
    ry: 10.5026,
    transform: "matrix(1 0 0 -1 14.9062 246.503)",
    fill: "url(#paint5_radial_4798_72393)",
    fillOpacity: 0.23
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4798_72393",
    x: 1.64062,
    y: 19.7617,
    width: 215.465,
    height: 215.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4798_72393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4798_72393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4798_72393",
    x: 39.7578,
    y: 56.7656,
    width: 139.363,
    height: 192.325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4798_72393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4798_72393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_4798_72393",
    x: 27.7578,
    y: 24.7656,
    width: 163.363,
    height: 181.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4798_72393"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_4798_72393",
    result: "effect2_dropShadow_4798_72393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4798_72393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bf_4798_72393",
    x: 69.3672,
    y: 52.7656,
    width: 93.7539,
    height: 125.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4798_72393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4798_72393",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect2_foregroundBlur_4798_72393"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4798_72393",
    x: 59.957,
    y: 79.6777,
    width: 100.18,
    height: 100.012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4798_72393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4798_72393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4798_72393",
    x: 5.90625,
    y: 216.498,
    width: 201.191,
    height: 39.0049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_4798_72393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4798_72393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.657 78.0261) rotate(77.2756) scale(136.674 136.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757636,
    stopColor: "#95EEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5F0E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4798_72393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.691 101.153) rotate(69.7498) scale(69.0549 56.0705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FFEC",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4798_72393",
    x1: 87.6564,
    y1: 73.5664,
    x2: 87.6564,
    y2: 111.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4798_72393",
    x1: 134.841,
    y1: 93.4503,
    x2: 93.8758,
    y2: 140.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81E0B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338368,
    stopColor: "#8EE896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504563,
    stopColor: "#5EC968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579971,
    stopColor: "#4DAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732658,
    stopColor: "#7CE186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99EBA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4798_72393",
    x1: 97.6814,
    y1: 114.253,
    x2: 110.578,
    y2: 104.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#60D26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#89E5A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4798_72393",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.8798 10.5026) scale(91.3126 10.7109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D232C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757636,
    stopColor: "#0F1827",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E242E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphereInfoFooterV2);
export default __webpack_public_path__ + "static/media/sphere-info-footer-v2.2ebfb100a4bd03fa99c1eed021b17634.svg";
export { ForwardRef as ReactComponent };